import http from "k6/http";

export interface LokiCredentials {
  host: string;
  auth: string;
}

export function nowNano(): string {
  return String(Date.now() * 1_000_000);
}

export function buildLogLine(
  level: string,
  message: string,
  extra: Record<string, unknown>,
): string {
  return JSON.stringify({
    level,
    message,
    timestamp: new Date().toISOString(),
    ...extra,
  });
}

export function pushToLoki(
  streams: unknown[],
  uuid: string | null,
  creds: LokiCredentials,
): void {
  const host = creds.host.startsWith("http")
    ? creds.host
    : `https://${creds.host}`;

  const res = http.post(
    `${host}/loki/api/v1/push`,
    JSON.stringify({ streams }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${creds.auth}`,
      },
    },
  );

  if (res.status !== 204) {
    throw new Error(`Loki push failed [${res.status}]: ${res.body}`);
  } else if (uuid) {
    console.log(`screenshot:${uuid}`);
  }
}
